import GroupProfileSubNavDesktopInner from './GroupProfileSubNavDesktopInner';
import GroupProfileSubNavDesktopInnerContainer from './GroupProfileSubNavDesktopInner.container';

export default GroupProfileSubNavDesktopInnerContainer(GroupProfileSubNavDesktopInner);
